import { Link } from "react-router";
import SectionLabel from "../components/SectionLabel";
import { Arrow } from "../components/Icons";
import AboutPortrait from "../components/AboutPortrait";

export default function AboutPreview() {
  return (
    <section id="about" className="about-preview section container">
      <AboutPortrait />
      <div className="about-copy">
        <SectionLabel index="03">Away from the screen</SectionLabel>
        <h2>
          A developer.
          <br />A runner.
          <br />A sense of rhythm.
        </h2>
        <p>
          Most of my time goes into a few things I care about: building for
          the web, distance running, and music.
        </p>
        <p>
          Running has taught me to keep showing up, even when progress is slow.
          Building a website takes some of that same patience, with plenty of
          small wins along the way.
        </p>
        <Link className="text-link" to="/about">
          A little more about me <Arrow diagonal />
        </Link>
      </div>
    </section>
  );
}
